module.exports = __webpack_public_path__ + "static/media/Day1.d99be573.jpg";